import {useMutation} from '@tanstack/react-query'
import api from 'src/services/api'

type ExportDetectionsDTO = {
  fileType: 'pdf' | 'csv'
  filter: {
    clientIds?: Array<number>
    cameraIds?: Array<number>
    companyIds?: Array<number>
    status?: Array<string>
  }
  start: string
  end: string
  offset?: number
  timeZone?: string
}

export default function useExportFacialDetectionsCountingAggregated() {
  const mutation = useMutation({
    mutationFn: async (data: ExportDetectionsDTO) => {
      return await api.reports.getExportFacialDetectionsCountingAggregated(data)
    },
  })

  return mutation
}
